import * as React from 'react';
import { NextSeo } from 'next-seo';
import Header from '../components/LandingPage/Header';
import HeroSection from '../components/LandingPage/HeroSection';
import FeaturesSection from '../components/LandingPage/FeaturesSection';
import SneakPeak from '../components/LandingPage/SneakPeak';
import AudienceSection from '../components/LandingPage/AudienceSection';
import InfluencerReview from '../components/LandingPage/InfluencerReview';
import Footer from '../components/LandingPage/Footer';
import ScrollToTop from '../components/LandingPage/Components/ScrollToTop';
import GDPRPopup from '../components/LandingPage/Components/GDPRPopup';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Link from 'next/link';

export default function Home() {
  return (
    <>
      <NextSeo
        title="Scriptu: Transform Your LinkedIn Presence with AI"
        description="Empower your LinkedIn with Scriptu's AI: Craft and schedule posts to transform your presence and boost engagement efficiently. Stand out, engage more effectively, and save hours every week with our intuitive tools."
        canonical="https://www.scriptu.io" // Add your canonical URL here
        openGraph={{
          url: "https://www.scriptu.io", // It's also good to set the URL in openGraph
          title: "Scriptu: Transform Your LinkedIn Presence with AI",
          description: "Empower your LinkedIn with Scriptu's AI: Craft and schedule posts to transform your presence and boost engagement efficiently. Stand out, engage more effectively, and save hours every week with our intuitive tools.",
          images: [
            {
              url: "/logo-promo.png",
              width: 2000,
              height: 520,
              alt: "Scriptu Logo",
            },
          ],
          site_name: "Scriptu",
        }}
        twitter={{
          handle: '@handle',
          site: '@site',
          cardType: 'summary_large_image',
        }}
        additionalLinkTags={[
          {
            rel: 'icon',
            href: '/favicon.png',
          },
          {
            rel: 'apple-touch-icon',
            href: '/favicon.png',
            sizes: '128x128',
          },
        ]}
      />
      <div style={{
        background: 'black',
        backgroundImage: 'url(/bg.jpg)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}>
        <div id="back-to-top-anchor"></div>
        <Header />
        <HeroSection />
        <FeaturesSection />
      </div>

      <SneakPeak />
      <AudienceSection />
      <InfluencerReview />

      {/*}
      <Box sx={{
        position: 'fixed', bottom: 0, left: 0, right: 0, p: 2,
        borderTop: '3px solid #b70d54',
        background: 'rgba(255, 255, 255, 0.95)', // Semi-transparent background
        color: 'black', textAlign: 'center', zIndex: 99,
        boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.2)',
        '@keyframes pulse': {
          '0%': { transform: 'scale(1)', boxShadow: '0 0 5px rgba(255, 0, 0, 0.6)' },
          '50%': { transform: 'scale(1.1)', boxShadow: '0 0 20px rgba(255, 0, 0, 1)' },
          '100%': { transform: 'scale(1)', boxShadow: '0 0 5px rgba(255, 0, 0, 0.6)' },
        },
        // Reduce the padding to make the box shorter
        padding: '10px 15px',
      }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <Typography variant="h6" sx={{
            fontWeight: 'bold',
            color: '#b70d54',
            textTransform: 'uppercase',
            mb: 0.5, // Reduce margin to save space
          }}>
            Limited Time Offer!
          </Typography>

          <Typography variant="body1" sx={{
            fontSize: '1.4rem', // Slightly smaller font size
            fontWeight: '800',
            color: '#212529',
            mb: 0.5,
          }}>
            Only <span style={{ color: '#b70d54', fontSize: '1.8rem' }}>$49.9</span> for a Lifetime Deal!
          </Typography>

          <Typography variant="body2" sx={{
            color: '#757575',
            mb: 1,
          }}>
            Hurry, this offer won&apos;t last long!
          </Typography>

          <Link href="/pricing" underline="none" hover="none">
          <Button sx={{
            color: 'white',
            padding: '8px 20px', // Reduce button padding
            background: 'linear-gradient(47deg, #b70da2, #ff0000)',
            border: '1px solid white',
            borderRadius: '25px', // Reduce border-radius
            fontSize: '1.1rem',
            animation: 'pulse 1.5s infinite',
            boxShadow: '0 0 15px rgba(255, 0, 0, 0.7)',
            transition: 'transform 0.3s',
            '&:hover': {
              transform: 'scale(1.05)',
            },
          }} >
            Grab the Deal Now!
          </Button>
          </Link>
        </Box>
      </Box>
      {*/}

      <Footer />




      <GDPRPopup />
      <ScrollToTop />
    </>
  );
}
